import * as React from 'react';
import { styled } from '../theme-provider';
import { getCommonProps } from '../helpers/common-props';
const StyledDivider = styled.hr.withConfig({ displayName: "StyledDivider", componentId: "sc-1g6khxq" }) `border:none;width:${(props) => props.isVertical ? props.theme.size.line.default : 'initial'};height:${(props) => props.isVertical ? '100%' : props.theme.size.line.default};margin:0;background-color:${(props) => props.theme.colors.border.divider};`;
export const Divider = (props) => {
    const { isVertical } = props;
    const commonProps = getCommonProps(props);
    return React.createElement(StyledDivider, Object.assign({ isVertical: isVertical }, commonProps));
};
Divider.displayName = 'Divider';
